import { Outlet, useLocation } from 'react-router-dom';
import { Toaster } from "react-hot-toast";
import Header from "./Header";
import Loader from "./Loader";
import Footer from "./Footer";
import { ModalLoginWindow } from 'utils/ModalLoginWindow';
import EventPlannedNavbar from '../EventPlannedLayout/EventPlannedNavbar';

const MainLayout = () => {
    const location = useLocation();
    const isEventPlanned = location.pathname.startsWith('/organizaciones-con-proposito');

    return (
        <>
            <Toaster />
            <Header />
            <EventPlannedNavbar isEventPlanned={isEventPlanned} />
            <Outlet />
            <ModalLoginWindow />
            <Footer />
        </>
        
    )

}

export default MainLayout;
